const globalConstants = {
    feedbackScenarioIds: {
        POSITIVE: '5b7147f098a4ed07f726a5ee',
        NEGATIVE: '5b7148ef98a4ed07f726a5ef'
    },
    botTypeBaseUrl: {
        POSTPAID: "chatMediator",
        PREPAID: "chatMediatorPrePaid",
        PAYMENTSBANK: "chatMediatorBank"
    },
    script: {
        welcomeScenarioWithoutMsisdnText: "Hello there! Hope you’re having a good day!",
        dffShowText: "Please provide us some of your details so that I can register a complaint on your behalf."
    },

    error: {
        limitReached: "You’ve tried the maximum number of times for today. Please come back after 24 hours and try again.",
        inCorrectOtp: "Oops! The OTP you've entered is incorrect. Please retry.",
        validateError: "Oops! Your OTP could not be validated. Please retry.",
        otpSendError: "Oops! Your OTP could not be sent. Please retry.",
        noPostpaidAccountMessage: "Oops! The mobile number you have entered is not a valid postpaid number. Kindly enter a Postpaid number.",
        loggedOutMessage: "It Seems you have logged out. Kindly relogin for smoother experience.",
        dffSubmitErrorMsg: "Oops! Something went wrong.",
        genericSRError: "Oops! An unexpected error has occurred, please try after sometime."
    },
    login_message: 'For a seamless experience, please login with your Airtel number.',
    login_again_message: 'Oops! Your session has expired. Please re-login.',
    login_successful_message: 'Great! You have successfully logged-in',
    default_error_message: 'Ooops.. something went wrong!',
    number_chosen_message: '',
    cancel_chatbot_response: ' Got it. Please share a new query or choose your query from the bottom left menu.',
    number_selected_acknowledgement_msg: ' Great! Let’s get started.',
    successful_switch_message: 'Great! You have successfully switched account to ',
    on_skip_message: 'Please type in your new query.',
    Scenario_Template_List: {
        "IR_Pack_Countries": "IR_Pack_Countries",
        "IR_PACKS_RECO": "IR_PACKS_RECO",
        "IR_RECO_DYN_PARAM": "IR_RECO_DYN_PARAM",
        "IR_PACKS_ALL": "IR_PACKS_ALL"
    },
    CONFIRMATION_FOR_SINGLE_ACCOUNT_WEB: {
        scenarioType: "ASK_NUMBER_CONFIRMATION_WEB",
        responseFirst: "Hello there! Hope you’re having a good day!",
        response: "Hey! Seems you're already logged-in to your account. Do you wish to continue chat for moblieNumbetPlaceholder ?",
        options: [
            {
                choiceId: "1",
                choiceText: "YES",
                displayText: "YES",
                nextStep: "2"
            },
            {
                choiceId: "2",
                choiceText: "NO",
                displayText: "NO",
                nextStep: "3"
            }
        ]
    },
    CONFIRMATION_FOR_MULTIPLE_CHATHISTORYREAD_APP: {
        scenarioType: "ASK_NUMBER_CONFIRMATION_FOR_MULTIPLE_CHATHISTORYREAD_APP",
        responseFirst: "Hello there! Hope you’re having a good day!",
        response: "Hey! You were chatting with number %mobilenumberplaceholder% . You wish to continue or switch account?",
        options: [
            {
                choiceId: "1",
                choiceText: "YES",
                displayText: "YES",
                nextStep: "2"
            },
            {
                choiceId: "2",
                choiceText: "NO",
                displayText: "NO",
                nextStep: "3"
            }
        ]
    },
    SESSION_EXPIRED_STATUS: {
        status: "UNAUTHORIZED",
        message: "Ooops.. something went wrong! Please type in query again."
    },
    TRACKING_EVENTS_CONSTANTS: {
        pageName: "leadIframe",
        source: (window.MyAirtelAppReact || window.MyAirtelChatAppReact) ? "APP" : "WEB",
        loginType: {
            "OTP": "OTP",
            "ALREADY_LOGGEDIN": "ALREADY_LOGGEDIN"
        }
    },
    USER_ACTION_TYPES: {
        'CHAT': 'SMART_SEARCH_CLICK',
        'PLACE': 'COUNTRY_SELECT',
        'DEFAULT': 'CHAT_TEXT_ENTER',
        'CATEGORY': 'CATEGORY_OPTION_CLICK'
    },
    INPUT_FIELD_TYPES: {
        'CHAT': 'CHAT',
        'PLACE': 'PLACE'
    },
    BOTTOM_BAR_COMPONENTS: {
        CHAT_INPUT_BAR: 'CHAT_BAR_COMPONENT',
        LOGIN_COMPONENT: 'LOGIN_COMPONENT',
        USER_ACCOUNTS_MENU: 'USER_ACCOUNTS_MENU',
        CANCEL_COMPONENT: 'CANCEL_COMPONENT',
        DFF_FORM_COMPONENT: 'DFF_FORM_COMPONENT'
    },
    CANCEL_CASES: {
        "IR_PACK": {
            title: "Cancel IR pack request?",
            message: "This will end your current session of IR pack request. Do you want to proceed?",
            cancel_user_response: 'I want to cancel my IR pack activation request'
        },
        "Eligible_Bill_Plans": {
            title: "Cancel plan change request?",
            message: "This will end your current session of plan change request. Do you want to proceed?",
            cancel_user_response: 'I want to cancel my plan change request'
        },
        "New_Bill_Plan": {
            title: "Cancel new plan request?",
            message: "This will end your current session of new plan request. Do you want to proceed?",
            cancel_user_response: 'I want to cancel my new plan request'
        },
        "IR_ACTIVATED_PACKS_DEACTIVATION": {
            title: "Cancel IR deactivation request?",
            message: "This will end your current session of IR pack deactivation request. Do you want to proceed?",
            cancel_user_response: 'I want to cancel my IR pack deactivation request'
        },
    },
};
export { globalConstants };


// WEBPACK FOOTER //
// ./src/constants/globalConstants.js